import { styled } from '@styles';

export const ColorCheckbox = styled.div`
  align-items: center;
  cursor: pointer;
  position: relative;
  margin: 3px;
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  input[type='checkbox'] {
    display: none;
    position: relative;
    right: -999em;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      border-radius: 50%;
      width: 46px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      .color-checkbox__icon {
        &-check,
        &-cross {
          display: none;
        }
      }
    }

    ${ColorCheckbox}:hover & {
      span {
        border: 4px solid rgba(255, 255, 255, 0.3);
      }
    }

    :focus {
      outline: none;
    }
  }

  input:checked + div {
    span {
      border: 4px solid rgba(255, 255, 255, 0.3);
      .color-checkbox__icon {
        &-check {
          display: block;
        }
      }
    }
    &:hover {
      span {
        .color-checkbox__icon {
          &-check {
            display: none;
          }
          &-cross {
            display: block;
          }
        }
      }
    }
  }
`;
